import SendSmsMessageDisplay from './SendSmsMessageDisplay'
import SendSmsMessageForm from './SendSmsMessageForm.container'
import IconMessageText from 'components/Icons/MessageText'

export default {
  id: 'send_sms_message',
  label: 'Send Sms Message',
  helpUrl: 'https://help.thinkpickle.com.au/flows/actions/send-sms-message',
  icon: IconMessageText,
  inputs: [{}],
  outputs: [{}],
  display: SendSmsMessageDisplay,
  form: SendSmsMessageForm,
  getPriceId: () => 'sendSmsMessage',
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendSmsMessage/index.js